var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"error-message",attrs:{"cols":"12","md":"12"}},[(_vm.error)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('vehicle.licenseOrVinRequired'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }